export default __webpack_public_path__ + "static/media/note-suvinil.e35a28e0.png";